function addMediaQueryWatcher(mediaQuery, layoutChangedCallback) {
    let mql = window.matchMedia(mediaQuery);

    try {
        mql.addEventListener((e) => { return layoutChangedCallback(e.matches); }); // Chrome & Firefox
    } catch (e1) {
        try {
            mql.addListener((e) => { return layoutChangedCallback(e.matches); }); // Safari
        } catch (e2) {
            console.error(e2);
        }
    }

    layoutChangedCallback(mql.matches);
}

/**
 * check if elements exists in the DOM, return elements if the exist otherwise return false
 * @param {string} selector the element to check
 * @return {node|string|boolean} returns the elements if they exist otherwise returns false
 */

function getElements( selector ) {
    if( selector instanceof NodeList && selector.length > 0 ) {
        return selector;
    }

    if( selector instanceof NodeList === false && selector !== null ) {
        return selector;
    }

    return false;
}
